import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

export const REPORT_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'report-change',
  predicate: ({ change }) => change.fieldPath === '/module_data/report',
  title: () => 'Updated report',
  render: () => <DeltaText oldText="" newText="Report updated" disableDiff />,
});
